import React, { useState } from 'react'
import { authService } from '../services/authService'

const LoginPopup = ({ onLogin }) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [verificationEmail, setVerificationEmail] = useState('')
  const [resendMessage, setResendMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')
    setVerificationEmail('')
    setResendMessage('')

    try {
      const data = await authService.login(username, password)
      onLogin(data.user)
    } catch (error) {
      if (error.code === 'EMAIL_VERIFICATION_REQUIRED') {
        setError('Nejdříve ověřte svůj e-mail.')
        setVerificationEmail(error.details?.email || username)
      } else if (error.status === 401) {
        setError('Nesprávné přihlašovací údaje')
      } else {
        setError('Chyba při přihlašování. Zkuste to znovu.')
      }
      setPassword('')
    } finally {
      setIsLoading(false)
    }
  }

  const handleResend = async () => {
    setResendMessage('')
    try {
      await authService.resendVerification(verificationEmail)
      setResendMessage('Nový ověřovací e-mail byl odeslán.')
    } catch (error) {
      setResendMessage(error.code === 'RESEND_TOO_SOON' ? 'Počkejte prosím minutu a zkuste to znovu.' : 'E-mail se nepodařilo odeslat.')
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Login Modal */}
      <div className="relative bg-white rounded-lg shadow-xl p-8 w-full max-w-md mx-4">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Přihlášení</h2>
          <p className="text-gray-600">Zadejte přihlašovací údaje pro přístup k aplikaci</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
              E-mail nebo uživatelské jméno
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="vas@email.cz"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
              enterKeyHint="next"
              required
              disabled={isLoading}
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Heslo
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Zadejte heslo"
              required
              disabled={isLoading}
              autoComplete="current-password"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              enterKeyHint="go"
            />
          </div>

          {error && <div className="text-red-600 text-sm text-center bg-red-50 p-2 rounded">{error}</div>}

          {verificationEmail && (
            <button type="button" onClick={handleResend} className="w-full text-sm font-medium text-blue-700 hover:text-blue-800">
              Poslat ověřovací e-mail znovu
            </button>
          )}
          {resendMessage && <div className="text-sm text-center text-gray-600">{resendMessage}</div>}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isLoading ? 'Přihlašování...' : 'Přihlásit'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default LoginPopup
